var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.biz)?_c('v-card',{attrs:{"flat":""}},[_c('v-toolbar',{attrs:{"dense":"","flat":""}},[_c('div',{staticClass:"subtitle-2"},[_vm._v("Business Licenses")]),_c('v-spacer'),_c('Create')],1),_c('List'),_c('ViewDocument')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }